import {
  Button,
  Container,
  CssBaseline,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  TextField,
  Typography,
} from "@mui/material";
import { Helmet } from "react-helmet-async";
import { StyledForm, StyledPaper } from "./styled";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { storeUser } from "@app/store/auth/auth.action";
import { User } from "@app/models/user.model";
import StorageService from "@core/services/storage";
import { Role } from "@app/constants";
import { useNavigate } from "react-router-dom";
import AuthService from "@app/services/http/auth.service";
import useObservable from "@core/hooks/use-observable.hook";

function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const [accountState, setAccountState] = useState({
    email: "",
    password: "",
  });

  const { subscribeOnce } = useObservable();

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setAccountState({
      ...accountState,
      [event.target.name]: event.target.value,
    });
  };

  const handleLogin = () => {
    const { email, password } = accountState;

    subscribeOnce(AuthService.login(email, password), (res) => {
      const { accessToken, email } = res;
      const user = new User({
        email,
        role: Role.MEMBER,
      });

      dispatch(storeUser(user));

      StorageService.setSession("access_token", accessToken);
      StorageService.setSession("role", Role.MEMBER);
      navigate("/home");
    });
  };

  return (
    <>
      <Helmet>
        <title>Login</title>
      </Helmet>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <StyledPaper>
          <Typography component="h1" variant="h5">
            LOGIN
          </Typography>
          <StyledForm>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email"
              name="email"
              autoComplete="email"
              onChange={handleInputChange}
            />
            <FormControl sx={{ mt: 1, mb: 1, width: 1 }} variant="outlined">
              <InputLabel htmlFor="password">Password*</InputLabel>
              <OutlinedInput
                id="password"
                label="Password"
                name="password"
                type={showPassword ? "text" : "password"}
                required
                onChange={handleInputChange}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label={
                        showPassword
                          ? "hide the password"
                          : "display the password"
                      }
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      onMouseUp={handleMouseUpPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
            <br />
            <Button
              id="btnSubmit"
              type="button"
              fullWidth
              variant="contained"
              color="primary"
              onClick={handleLogin}
            >
              Login
            </Button>
          </StyledForm>
        </StyledPaper>
      </Container>
    </>
  );
}

export default Login;
